import { gql } from '@apollo/client';
import { TopicCollection } from '../types';
import performQuery from './contentfulClient';

const TOPICS_ARTICLES_COLLECTION = gql`
  query TopicsAndArticles($preview: Boolean) {
    ansKbTopicCollection(where: { externalUrl_exists: false }, limit: 16, order: sortOrder_ASC, preview: $preview) {
      total
      items {
        sys {
          id
          spaceId
        }
        topicName
        slug
        previewDescription
        linkedFrom {
          ansArticleCollection(order: sortOrder_ASC) {
            items {
              sys {
                id
                spaceId
              }
              slug
              articleTitle
            }
          }
        }
      }
    }
  }
`;

export const useTopicsWithArticlesQuery = async () => {
  const response = await performQuery(TOPICS_ARTICLES_COLLECTION, {});

  if (response.hasError) {
    return {
      data: null,
      error: true,
    };
  }

  return {
    data: response.res?.data as TopicCollection | null,
    error: false,
  };
};
